const NoPage = () => {
    return <h1>Stranica ne postoji: greška 404!</h1>;
};

export default NoPage;
